{
  "common": {
    "save": "Speichern",
    "cancel": "Abbrechen",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "close": "Schließen",
    "submit": "Absenden",
    "search": "Suchen",
    "loading": "Wird geladen...",
    "yes": "Ja",
    "no": "Nein",
    "back": "Zurück",
    "next": "Weiter",
    "previous": "Zurück",
    "confirm": "Bestätigen",
    "done": "Fertig",
    "remove": "Entfernen",
    "add": "Hinzufügen",
    "view": "Anzeigen",
    "create": "Erstellen",
    "update": "Aktualisieren",
    "ok": "OK",
    "none": "Keine",
    "na": "K. A.",
    "prepare": "Vorbereiten",
    "approve": "Genehmigen",
    "uploadFiles": "Dateien hochladen",
    "learnMore": "Mehr erfahren",
    "user": "Benutzer",
    "users": "Benutzer"
  },
  "nav": {
    "users": "Benutzer",
    "groups": "Gruppen",
    "developerApiTokens": "Entwickler-API-Token",
    "permissions": "Berechtigungen",
    "betaFeatures": "Beta-Funktionen",
    "security": "Sicherheit",
    "adminSettings": "Admin-Einstellungen"
  },
  "pages": {
    "unauthorized": {
      "title": "Nicht autorisiert",
      "heading": "Tut uns leid!",
      "message": "Es scheint, dass Sie keinen Zugriff auf diese Seite haben.",
      "contactSupport": "Wenn Sie denken, dass dies ein Fehler ist, kontaktieren Sie bitte unseren Customer Success."
    },
    "errorBoundary": {
      "message": "Etwas ist schief gelaufen!"
    },
    "passwords": {
      "title": "Passwörter-Seite",
      "description": "Wenn diese Option aktiviert wird, wird jeder in Ihrer Organisation gezwungen, sein Passwort in regelmäßigen Abständen zu ändern."
    },
    "singleSignOn": {
      "title": "Single Sign-On-Seite"
    },
    "logo": {
      "title": "Logo hochladen",
      "description": "Laden Sie das Logo Ihrer Organisation hier hoch und es wird in exportierten Dokumenten angezeigt."
    }
  },
  "users": {
    "searchPlaceholder": "Benutzer suchen...",
    "filterByGroup": "Nach Gruppe filtern",
    "inviteUser": "Benutzer einladen",
    "setRole": "Rolle festlegen",
    "addToGroup": "Zur Gruppe hinzufügen",
    "addToGroupCount": "{{count}} {{pluralized}} zur Gruppe hinzufügen",
    "removeFromGroup": "Aus Gruppe entfernen",
    "removeFromGroupCount": "{{count}} {{pluralized}} aus Gruppe entfernen",
    "manageGroups": "Manage groups",
    "manageGroupsCount": "Manage groups for {{count}} {{pluralized}}",
    "editUser": "Benutzer bearbeiten",
    "removeUser": "Benutzer entfernen",
    "cancelInvitation": "Einladung abbrechen",
    "resendInvitation": "Einladung erneut senden",
    "usageMessage": "Sie verwenden {{activeUsersCount}} von {{activeUsersLimit}} aktiven Benutzern und {{totalUsersCount}} von {{totalUsersLimit}} insgesamt verfügbaren Benutzern in Ihrem aktuellen Plan. Benötigen Sie mehr?",
    "upgradeSubscription": "Upgraden Sie Ihr Abonnement",
    "addMoreSeats": "Weitere Lizenzen hinzufügen",
    "table": {
      "fullName": "Vollständiger Name",
      "email": "E-Mail",
      "role": "Rolle",
      "jobTitle": "Berufsbezeichnung",
      "department": "Abteilung",
      "location": "Standort",
      "groups": "Gruppen",
      "access": "Zugriff"
    },
    "inviteStatus": {
      "pending": "ausstehend",
      "declined": "abgelehnt",
      "accepted": "akzeptiert"
    },
    "editUsersUsage": "Benutzer bearbeiten (Normal + Qualität): {{activeUsersCount}} von {{activeUsersLimit}}",
    "basicUsersUsage": "Basisbenutzer: {{basicUsersCount}} von {{basicUsersLimit}}",
    "basicUsersUsageUnlimited": "Basisbenutzer: {{basicUsersCount}} (Unbegrenzt)"
  },
  "reassignEntities": {
    "cancel": "Abbrechen",
    "makeReassignments": "Neuzuweisungen vornehmen",
    "previous": "Zurück",
    "next": "Weiter",
    "removeUser": "Benutzer entfernen",
    "confirm": "Bestätigen",
    "save": "Speichern",
    "allSelected": "Alle {{count}} ausgewählt:",
    "reviewInfo": "Überprüfen Sie die folgenden Informationen",
    "addUserToGroup": "Benutzer zur Gruppe hinzufügen",
    "warningMessage": "Wenn Sie mit der Entfernung fortfahren, werden die folgenden Benutzer den folgenden Gruppen hinzugefügt, die für den Zugriff auf Dokumente mit privaten Tags erforderlich sind:",
    "userAddedToGroups": "{{userName}} wird den Gruppen hinzugefügt:",
    "steps": {
      "owner": "Dokumente",
      "changeRequestOwner": "Änderungsanträge",
      "approver": "Genehmigungsaktionen",
      "reviewer": "Überprüfungsaktionen",
      "issues": "Probleme",
      "events": "Ereignisse",
      "tasks": "Aufgaben",
      "summary": "Änderungen bestätigen und Benutzer entfernen",
      "summaryRefactor": "Benutzerentfernung bestätigen",
      "default_owner": "Standard-Ereigniszuweiser",
      "eventTemplateOwner": "Ereignisvorlagen",
      "control": "Kontrollen",
      "documentTemplateOwner": "Dokumentvorlagen"
    },
    "columns": {
      "id": "ID",
      "title": "Titel",
      "newOwner": "Neuer Eigentümer",
      "status": "Status",
      "tags": "Tags",
      "name": "Name",
      "prefix": "Präfix"
    },
    "summary": {
      "documents": "Dokumente:",
      "documentTemplates": "Dokumentvorlagen:",
      "changeRequests": "Änderungsanträge:",
      "controls": "Kontrollen:",
      "eventTemplates": "Ereignisvorlagen:",
      "approvalActions": "Genehmigungsaktionen:",
      "reviewActions": "Überprüfungsaktionen:",
      "issueActions": "Problemaktionen:",
      "eventActions": "Ereignisaktionen:",
      "issueCollaboratorNote": "Ist ein neuer Eigentümer bereits Mitwirkender eines Ereignisses, wird er aus der Liste der Mitwirkenden entfernt.",
      "taskActions": "Aufgabenaktionen:",
      "ownershipTransfer": "Eigentümerschaft von {{count}} {{type}} wird auf {{name}} übertragen",
      "ownershipTransferPlural": "Eigentümerschaft von {{count}} {{type}}s wird auf {{name}} übertragen",
      "actionTransfer": "{{count}} {{type}}-Aktion wird auf {{name}} übertragen",
      "actionTransferPlural": "{{count}} {{type}}-Aktionen werden auf {{name}} übertragen",
      "eventTemplateTransfer": "{{ownershipType}} von {{count}} Ereignisvorlage wird auf {{name}} übertragen",
      "eventTemplateTransferPlural": "{{ownershipType}} von {{count}} Ereignisvorlagen werden auf {{name}} übertragen"
    }
  },
  "groups": {
    "subtitle": "Erstellen und verwalten Sie Benutzergruppen, um Ihr Team zu organisieren und den Zugriff zu steuern",
    "createNewGroup": "Neue Gruppe erstellen",
    "assignManagers": "Manager zuweisen",
    "editGroup": "Gruppe bearbeiten",
    "deleteGroup": "Gruppe löschen",
    "confirmDeleteTitle": "Löschen der Gruppe bestätigen",
    "confirmDeleteMessage": "Sind Sie sicher, dass Sie die Gruppe \"{{groupName}}\" löschen möchten? Das Löschen einer Gruppe, die Teil eines Qualio-Schulungsplans ist, kann Ihre Schulungszuweisungen beeinflussen. Bitte überprüfen Sie die Schulungsmatrix, um betroffene Pläne zu identifizieren.",
    "yesDeleteGroup": "Ja, Gruppe löschen",
    "searchPlaceholder": "Gruppen oder Manager suchen...",
    "table": {
      "groupName": "Gruppenname",
      "groupManagers": "Gruppenmanager",
      "includeInReports": "In Schulungsberichte einbeziehen"
    },
    "noManagers": "--"
  },
  "groupForm": {
    "groupName": "Gruppenname",
    "includeInReports": "In Berichte einbeziehen",
    "minLengthError": "Mindestlänge von 1 Zeichen erforderlich.",
    "duplicateError": "Gruppe mit dem Namen \"{{groupName}}\" existiert bereits."
  },
  "roles": {
    "basic": "Basis",
    "normal": "Normal",
    "quality": "Qualität"
  },
  "features": {
    "qualityEvents": {
      "name": "Qualitätsereignisse",
      "description": "Ein \"Qualitätsereignis\" ist ein Ereignis, das eine vordefinierte Aktion oder Antwort und Verfolgung gemäß behördlicher Anforderungen erfordert. Qualitätsbenutzer können ein Ereignis erstellen, Eigentümerschaft zuweisen und mit zugehörigen Schritten/Maßnahmen abmelden.",
      "enable": "Qualitätsereignisse aktivieren",
      "permissions": {
        "manageWorkflow": "Workflow verwalten",
        "manageAttributes": "Attribute verwalten",
        "workOnIssue": "An Problem arbeiten",
        "createIssue": "Problem erstellen",
        "view": "Ereignisse anzeigen",
        "create": "Ein Ereignis erstellen",
        "workOnExisting": "An einem bestehenden Ereignis arbeiten",
        "manageTemplates": "Ereignisvorlagen erstellen und verwalten"
      }
    },
    "migrations": {
      "name": "Migrationen",
      "description": "Mit dem Migrationsmanager können Sie beim Onboarden problemlos Dokumente in Qualio hochladen.",
      "enable": "Migrationen aktivieren",
      "permissions": {
        "create": "Erstellen",
        "view": "Anzeigen",
        "prepare": "Vorbereiten",
        "approve": "Genehmigen",
        "uploadFiles": "Dateien hochladen"
      }
    },
    "suppliers": {
      "name": "Lieferanten",
      "description": "Die Lieferantenfunktion ermöglicht es Ihrem Team, Ihre Lieferantenpolitik zu konfigurieren, Ihre Liste der genehmigten Lieferanten zu verwalten und Lieferantenauditdokumente zu speichern.",
      "access": "Auf Lieferanten zugreifen"
    },
    "designControls": {
      "name": "Design-Kontrollen",
      "description": "Die Design-Kontrollen-Funktion ermöglicht eine effiziente Verwaltung und Dokumentation des Design- und Entwicklungsprozesses Ihres Produkts und gewährleistet Regelkonformität und Qualität.",
      "access": "Auf Design-Kontrollen zugreifen"
    },
    "compliance": {
      "name": "Regelkonformität",
      "description": "Die Regelkonformität-Funktion ermöglicht es Ihrem Team, Frameworks zu verwalten, den Anforderungsstatus zu verfolgen und die Einhaltung von Qualitäts- und behördlichen Standards zu demonstrieren.",
      "access": "Auf Regelkonformität zugreifen"
    },
    "apiCapabilities": {
      "name": "API-Funktionen",
      "description": "API-Funktionen ermöglichen den Zugriff auf programmierbare Schnittstellen für eine nahtlose Integration und Automatisierung Ihrer Unternehmenssysteme mit Qualio-Dokumenten und Schulungen.",
      "access": "Auf API-Funktionen zugreifen",
      "deprecatedNote": "Dies ermöglicht den Zugriff nur auf die ältere API. Bitte verwenden Sie \"Entwickler-API-Token\", um Zugriff auf die neue API zu gewähren."
    },
    "events": {
      "name": "Ereignisse",
      "description": "Die Ereignisfunktion ermöglicht es Ihrem Team, alle Qualitätsereignisse von der Grundursache bis zur Überprüfung der Wirksamkeit zu erstellen und zu verwalten."
    },
    "notAvailable": "Diese Funktion ist mit Ihrer aktuellen Lizenz nicht verfügbar. Bitte kontaktieren Sie Ihren Customer Success-Vertreter, um Qualitätsereignisse zu upgraden und zu aktivieren.",
    "disableConfirmation": "Vorhandene Daten werden gespeichert und stehen zur Verfügung, wenn die Funktionen wieder aktiviert werden. Alle Benutzergenehmigungen, die geändert wurden, werden jedoch gelöscht und auf ihren Standard-Zugriff zurückgesetzt, wenn die Funktion wieder aktiviert wird. Sind Sie sicher, dass Sie deaktivieren möchten?",
    "disableTitle": "{{name}} deaktivieren",
    "yesDisable": "Ja, {{name}} deaktivieren",
    "enable": "Funktion aktivieren",
    "disable": "{{name}} deaktivieren",
    "role": "Rolle",
    "access": "Zugriff",
    "none": "Keine",
    "upgradeMessage": "Diese Funktion ist mit Ihrer aktuellen Lizenz nicht verfügbar. Bitte kontaktieren Sie Ihren Customer Success-Vertreter, um ein Upgrade durchzuführen und Qualitätsereignisse zu aktivieren."
  },
  "status": {
    "draft": "Entwurf",
    "forReview": "Zur Überprüfung",
    "forApproval": "Zur Genehmigung",
    "approved": "Genehmigt",
    "approvalDeclined": "Genehmigung abgelehnt",
    "effective": "Wirksam"
  },
  "forms": {
    "fullName": "Vollständiger Name",
    "email": "E-Mail-Adresse",
    "role": "Benutzerrolle",
    "adminAccess": "Administratorzugriff",
    "billingAccess": "Abrechnungszugriff",
    "learnMoreRoles": "Mehr über Benutzerrollen erfahren.",
    "labels": {
      "fullName": "Vollständiger Name",
      "emailAddress": "E-Mail-Adresse",
      "userRole": "Benutzerrolle",
      "jobTitle": "Berufsbezeichnung",
      "department": "Abteilung",
      "location": "Standort",
      "adminAccess": "Admin-Zugriff",
      "billingAccess": "Abrechnungszugriff",
      "name": "Name",
      "role": "Rolle",
      "groups": "Gruppen"
    },
    "placeholders": {
      "whatIsThisTokenFor": "Wofür ist dieses Token?",
      "filterByNameEmailGroup": "Nach Name, E-Mail oder Gruppenname filtern..."
    },
    "helperText": {
      "adminAccess": "Das Gewähren von Admin-Zugriff ermöglicht es Benutzern, Benutzer und Gruppen hinzuzufügen/zu entfernen und Berechtigungen zu bearbeiten",
      "adminAccessExtended": "Das Gewähren von Admin-Zugriff ermöglicht es Benutzern, Benutzer hinzuzufügen/zu entfernen, Gruppen hinzuzufügen/zu entfernen und Berechtigungen für Ereignisse und Lieferanten zu verwalten",
      "inviteUser": "Eine Einladungsnachricht wird an die angegebene E-Mail-Adresse gesendet. Sie enthält einen Bestätigungslink, mit dem der Besitzer der E-Mail-Adresse Ihre Organisation beitreten kann.",
      "learnMoreRoles": "Erfahren Sie mehr über Benutzerrollen.",
      "learnMorePermissions": "Erfahren Sie mehr über Berechtigungen."
    },
    "permissions": {
      "viewEvents": "Ereignisse anzeigen",
      "createEvents": "Ein Ereignis erstellen",
      "editEvents": "An einem vorhandenen Ereignis arbeiten",
      "manageEvents": "Ereignisvorlagen erstellen und verwalten",
      "accessSuppliers": "Zugriff auf Lieferanten",
      "accessDesignControls": "Zugriff auf Design-Kontrollen",
      "accessCompliance": "Zugriff auf Regelkonformität"
    }
  },
  "apiCapabilities": {
    "header": "API-Funktionen",
    "description": "API-Funktionen ermöglichen den Zugriff auf programmierbare Schnittstellen für nahtlose Integration und Automatisierung Ihrer Unternehmenssysteme mit Qualio-Dokumenten und -Schulungen.",
    "deprecatedDescription": "Dies ermöglicht nur den Zugriff auf die Legacy-API. Bitte verwenden Sie \"Entwickler-API-Token\", um Zugriff auf die neue API zu gewähren.",
    "errorFetchKeys": "Konnte nicht feststellen, ob das Unternehmen API-Schlüssel hat, aufgrund eines Serverfehlers.",
    "access": "Zugriff auf API-Funktionen"
  },
  "modals": {
    "inviteUser": {
      "title": "Benutzer einladen",
      "sendInvitation": "Einladung senden",
      "resendInvitation": "Einladung erneut senden",
      "reinviteMessage": "{{email}} war zuvor ein aktives Mitglied dieses Kontos. Wenn Sie sie erneut einladen, wird ihr Profil mit zuvor abgeschlossenen Aktivitäten wiederhergestellt."
    },
    "setRole": {
      "title": "Rolle für ausgewählte Benutzer festlegen"
    },
    "addToGroup": {
      "title": "Ausgewählte Benutzer zur Gruppe hinzufügen"
    },
    "manageGroups": {
      "title": "Manage groups for selected users",
      "save": "Save",
      "saving": "Saving...",
      "searchPlaceholder": "Filter by group name..."
    },
    "removeFromGroup": {
      "title": "Ausgewählte Benutzer aus Gruppe entfernen",
      "visibilityWarning": "Wenn Sie die ausgewählten Benutzer aus dieser Gruppe entfernen, werden einige Dokumente oder Vorlagen vor ihren Besitzern verborgen. Möchten Sie wirklich fortfahren?",
      "confirmTitle": "Diese Aktion wirkt sich auf die Dokumentsichtbarkeit aus"
    },
    "removeUser": {
      "title": "Benutzer entfernen",
      "confirmMessage": "Sind Sie sicher, dass Sie den Benutzer \"{{name}}\" entfernen möchten?",
      "yesRemoveUser": "Ja, Benutzer entfernen"
    },
    "cancelInvite": {
      "title": "Einladung abbrechen",
      "confirmMessage": "Sind Sie sicher, dass Sie die Einladung dieses Benutzers abbrechen möchten?",
      "yesCancelUser": "Ja, Benutzer abbrechen"
    },
    "assignManagers": {
      "title": "Manager zuweisen",
      "searchPlaceholder": "Nach Name, E-Mail oder Gruppenname filtern...",
      "assigning": "Manager werden zugewiesen...",
      "save": "Speichern"
    },
    "editUser": {
      "title": "Benutzer bearbeiten"
    },
    "editGroup": {
      "title": "Gruppe bearbeiten"
    }
  },
  "editUser": {
    "title": "Benutzer bearbeiten",
    "header": "Benutzer bearbeiten",
    "general": "Allgemein",
    "permissions": "Berechtigungen",
    "defaultPermissions": "Standardberechtigungen",
    "events": "Ereignisse",
    "suppliers": "Lieferanten",
    "designControls": "Design-Kontrollen",
    "compliance": "Regelkonformität",
    "eventsDescription": "Die Ereignisfunktion ermöglicht es Ihrem Team, alle Qualitätsereignisse von der Ursachenanalyse bis zur Wirksamkeitsprüfung zu erstellen und zu verwalten",
    "suppliersDescription": "Die Lieferantenfunktion ermöglicht es Ihrem Team, Ihre Lieferantenrichtlinie zu konfigurieren, Ihre Liste genehmigter Lieferanten zu verwalten und Lieferanten-Audit-Dokumente zu speichern",
    "designControlsDescription": "Die Design-Kontrollen-Funktion ermöglicht eine effiziente Verwaltung und Dokumentation des Design- und Entwicklungsprozesses Ihres Produkts und gewährleistet Regelkonformität und Qualität.",
    "complianceDescription": "Die Regelkonformität-Funktion ermöglicht es Ihrem Team, Frameworks zu verwalten, den Anforderungsstatus zu verfolgen und die Einhaltung von Qualitäts- und regulatorischen Standards nachzuweisen.",
    "eventsWarning": "Das Anzeigen von Ereignissen muss aktiviert sein, um zusätzliche Berechtigungen zu aktivieren",
    "viewEventsWarning": "Das Anzeigen von Ereignissen muss aktiviert sein, um zusätzliche Berechtigungen zu aktivieren",
    "resetPermissions": "Auf Standardberechtigungen zurücksetzen",
    "resetToDefault": "Auf Standardberechtigungen zurücksetzen",
    "saveChanges": "Änderungen speichern",
    "eventsPermissions": "Ereignisberechtigungen",
    "defaultPermissionsTable": {
      "role": "Rolle",
      "defaultPermissions": "Standardberechtigungen"
    },
    "validation": {
      "invalidFullName": "Ungültiger vollständiger Name",
      "invalidEmail": "Ungültige E-Mail-Adresse"
    }
  },
  "messages": {
    "success": {
      "saved": "Erfolgreich gespeichert",
      "deleted": "Erfolgreich gelöscht",
      "submitted": "Zur Überprüfung eingereicht",
      "invitationSent": "Einladung gesendet!",
      "invitationResent": "Einladung wurde erneut gesendet!",
      "invitationCanceled": "Benutzereinladung erfolgreich abgebrochen.",
      "userRemoved": "Benutzer erfolgreich entfernt.",
      "userDeleted": "Benutzer erfolgreich gelöscht!",
      "userUpdated": "Benutzer erfolgreich aktualisiert!",
      "groupCreated": "Gruppe erfolgreich erstellt!",
      "groupDeleted": "Gruppe erfolgreich gelöscht!",
      "groupUpdated": "Gruppe erfolgreich aktualisiert!",
      "roleChanged": "Rolle für {{count}} Benutzer erfolgreich geändert!",
      "usersAdded": "{{count}} Benutzer erfolgreich zur ausgewählten Gruppe hinzugefügt",
      "usersRemoved": "{{count}} Benutzer erfolgreich aus ausgewählter Gruppe entfernt",
      "groupsUpdated": "Successfully updated group membership!",
      "managersAssigned": "Manager erfolgreich zugewiesen",
      "permissionsUpdated": "Instanzberechtigungen erfolgreich aktualisiert",
      "tokenCreated": "Neuer Token erstellt",
      "tokenDeleted": "Entwickler-API-Token erfolgreich gelöscht",
      "tokenUpdated": "Entwickler-API-Token erfolgreich aktualisiert"
    },
    "error": {
      "generic": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
      "notFound": "Element nicht gefunden",
      "unauthorized": "Sie sind nicht autorisiert, diese Aktion auszuführen",
      "sendInvitation": "Etwas ist schief gelaufen! Einladung konnte nicht gesendet werden.",
      "resendInvitation": "Etwas ist schief gelaufen! Einladung konnte nicht erneut gesendet werden.",
      "cancelInvitation": "Etwas ist schief gelaufen! Benutzereinladung konnte nicht abgebrochen werden.",
      "removeUser": "Etwas ist schief gelaufen! Benutzer konnte nicht entfernt werden.",
      "updateUser": "Etwas ist schief gelaufen! Benutzer konnte nicht aktualisiert werden.",
      "extractOwnedItems": "Etwas ist schief gelaufen! Eigene Elemente für diesen Benutzer konnten nicht extrahiert werden.",
      "createGroup": "Etwas ist schief gelaufen! Gruppe konnte nicht erstellt werden.",
      "deleteGroup": "Etwas ist schief gelaufen! Gruppe konnte nicht gelöscht werden.",
      "updateGroup": "Etwas ist schief gelaufen! Gruppe konnte nicht aktualisiert werden.",
      "updateRole": "Etwas ist schief gelaufen! Rolle konnte nicht aktualisiert werden.",
      "setUsersToGroup": "Benutzer konnten nicht auf ausgewählte Gruppe eingestellt werden",
      "addUsersToGroup": "Benutzer konnten nicht auf ausgewählte Gruppe eingestellt werden",
      "removeUsersFromGroup": "Benutzer konnten nicht aus ausgewählter Gruppe entfernt werden",
      "manageGroups": "Unable to update group membership. Please try again.",
      "assignManagers": "Fehler beim Zuweisen von Managern",
      "updateMfa": "MFA-Status für dieses Unternehmen konnte nicht aktualisiert werden",
      "updatePermissions": "Fehler beim Aktualisieren von Instanzberechtigungen",
      "loadSettings": "Fehler beim Laden der Einstellungen.",
      "fetchFeatures": "Fehler beim Abrufen von Funktionen",
      "updateFeatures": "Fehler beim Aktualisieren von Funktionen",
      "createToken": "Das angeforderte API-Schlüssel konnte aufgrund eines Serverfehlers nicht erstellt werden",
      "tokenNameExists": "Ein API-Schlüssel mit diesem Namen existiert bereits. Bitte wählen Sie einen anderen Namen.",
      "deleteToken": "Das angeforderte API-Schlüssel konnte aufgrund eines Serverfehlers nicht gelöscht werden",
      "rotateToken": "Das angeforderte API-Schlüssel konnte aufgrund eines Serverfehlers nicht rotiert werden",
      "showApiKeys": "API-Schlüssel konnten aufgrund eines Serverfehlers nicht angezeigt werden",
      "reassignEntities": "Fehler bei der Neuzuweisung von Entitäten. Bitte versuchen Sie es erneut.",
      "updateToken": "Der angeforderte API-Token konnte aufgrund eines Serverfehlers nicht aktualisiert werden"
    },
    "validation": {
      "required": "Dieses Feld ist erforderlich",
      "invalidEmail": "Ungültige E-Mail-Adresse.",
      "minLength": "Mindestens {{min}} Zeichen erforderlich",
      "maxLength": "Nicht mehr als {{max}} Zeichen erforderlich",
      "invalidTokenName": "Ungültiger Token-Name",
      "minimumAdmins": "Dieser Vorgang würde zu null Administratoren für das Unternehmen führen. Die erforderliche Mindestanzahl von Administratoren für jedes Unternehmen beträgt 1.",
      "minimumQuality": "Das Unternehmen benötigt mindestens einen Qualitätsbenutzer.",
      "documentsHidden": "Diese Aktion würde dazu führen, dass ein oder mehrere Dokumente vor ihren Besitzern verborgen werden.",
      "templatesHidden": "Diese Aktion würde dazu führen, dass eine oder mehrere Vorlagen vor ihren Besitzern verborgen werden.",
      "userAlreadyExists": "Benutzer, der mit E-Mail {{email}} registriert ist, ist bereits Mitglied dieses Unternehmens.",
      "totalUsersLimit": "Limit für Gesamtbenutzer erreicht.",
      "activeUsersLimit": "Limit für aktive Benutzer erreicht.",
      "userExistsInQualio": "Ein Benutzer existiert bereits in Qualio mit dieser E-Mail-Adresse."
    }
  },
  "emptyStates": {
    "noResults": "Keine Ergebnisse gefunden",
    "noData": "Es gibt keine Daten zum Anzeigen.",
    "noBetaFeatures": {
      "title": "Keine aktiven Beta-Funktionen verfügbar",
      "subtitle": "Bitte überprüfen Sie später erneut. Wir arbeiten ständig an Verbesserungen der Qualio-Erfahrung."
    },
    "noApiTokens": {
      "title": "Keine API-Token erstellt",
      "subtitle": "Benötigen Sie ein API-Token für Skripte oder Tests? Generieren Sie ein API-Token für schnellen Zugriff auf die Qualio-API.",
      "viewPortal": "Entwicklerportal anzeigen",
      "createToken": "Token erstellen"
    },
    "noApiAccess": {
      "title": "Sie haben keinen Zugriff auf die Entwickler-API",
      "subtitle": "Kontaktieren Sie unser Support-Team, damit Sie auf die Entwickler-API in Qualio zugreifen können.",
      "contactSupport": "Qualio-Support kontaktieren"
    }
  },
  "security": {
    "description": "Verwalten Sie Authentifizierungsanforderungen und Sicherheitseinstellungen für alle Benutzer in Ihrer Organisation.",
    "mfa": {
      "label": "Multi-Faktor-Authentifizierung",
      "description": "Erfordern Sie, dass alle Benutzer in Ihrer Organisation zusätzlich zu ihrem Passwort einen Verifizierungscode angeben, wenn sie sich anmelden, um die Gesamtsicherheit zu erhöhen.",
      "enable": "Multi-Faktor-Authentifizierung aktivieren",
      "disableTitle": "Multi-Faktor-Authentifizierung deaktivieren",
      "disableMessage": "Sind Sie sicher, dass Sie diese Einstellung deaktivieren möchten? Benutzer müssen sich nach der Deaktivierung nicht mit Multi-Faktor-Authentifizierung anmelden."
    }
  },
  "permissions": {
    "instancePermissions": "Instanzberechtigungen",
    "aiEditing": {
      "label": "KI-gestützte Bearbeitung",
      "description": "Vorgeschlagene Schulungsbewertungen, Änderungskontrollen und Dokumentverbesserungen mit KI-Unterstützung.",
      "enable": "KI-gestützte Bearbeitung aktivieren"
    },
    "mcp": {
      "label": "MCP-Zugriff",
      "description": "Ermöglichen Sie KI-Assistenten und -Agenten den Zugriff auf diese Instanz über den MCP-Server von Qualio.",
      "enable": "MCP-Zugriff aktivieren"
    },
    "copilot": {
      "label": "Qualio Copilot",
      "description": "Aktivieren Sie den KI-Assistenten Qualio Copilot für diese Instanz.",
      "enable": "Copilot aktivieren"
    },
    "reviewers": {
      "label": "Prüfer",
      "description": "Gewähren Sie Basisbenutzer die Berechtigung, als Prüfer in Dokumenten hinzugefügt zu werden.",
      "enable": "Alle Basisbenutzer können Prüfer sein"
    },
    "supportAccess": {
      "label": "Qualio-Support-Zugriff",
      "description": "Ermöglichen Sie Qualio Support, auf Ihre Instanz im schreibgeschützten Modus zuzugreifen.",
      "enable": "Support-Zugriff aktivieren"
    },
    "saveChanges": "Änderungen speichern",
    "termsOfService": {
      "prefix": "Mit",
      "tos": "markierte Berechtigungen aktivieren KI-gestützte Funktionen. Durch deren Aktivierung stimmen Sie den Servicebedingungen von Qualio zu.",
      "fairUsage": "Um eine konsistente Erfahrung für alle Nutzer zu gewährleisten, können wir in Zeiten hoher Nachfrage Nutzungslimits einführen."
    }
  },
  "betaFeatures": {
    "description": "Erkunden und testen Sie die neuesten Funktionen, die wir entwickeln, indem Sie sie in Ihrer Instanz aktivieren. Ihr Feedback hilft uns, diese Innovationen zu verfeinern und zu perfektionieren, teilen Sie also Ihre Meinung mit. Wenn Sie eine Beta-Funktion aktivieren, kann es einige Minuten dauern, bis die Änderung wirksam wird. Falls Sie die Änderungen nicht sehen, aktualisieren Sie Ihren Browser. Erfahren Sie mehr über diese Funktionen in unserem",
    "helpCenter": "Hilfezentrum.",
    "packageNotice": "Der Zugang zu Beta-Funktionen nach der allgemeinen Verfügbarkeit kann von Ihrem Paket abhängen. Wenden Sie sich an Ihren CSM, um mehr zu erfahren.",
    "enabled": "{{name}} aktiviert",
    "disabled": "{{name}} deaktiviert",
    "enable": "{{name}} aktivieren",
    "termsOfService": {
      "prefix": "Durch Klicken auf einen Schalter zum Aktivieren einer der folgenden Beta-Funktionen stimmen Sie zu, an Qualio gebunden zu sein",
      "terms": "Servicebedingungen,",
      "middle": "wobei die Beta-Funktionen, die Sie aktivieren, Teil der \"Beta-Funktionen\" für die Zwecke des",
      "suffix": "Servicebedingungen sind."
    }
  },
  "devApi": {
    "backToTokens": "Zurück zu API-Token",
    "createToken": "Token erstellen",
    "tokenRoleHelper": "Welche Rolle sollte dieser Token haben?",
    "adminAccessHelper": "Gewähren Sie diesem Token die Möglichkeit, Benutzer hinzuzufügen/zu entfernen, Gruppen hinzuzufügen/zu entfernen und Berechtigungen für Ereignisse und Lieferanten zu verwalten.",
    "tokenGroupsHelper": "Fügen Sie dieses Token optional zu Gruppen hinzu, um ihm Zugriff auf private Dokumente, Ereignisse usw. zu ermöglichen, genau wie einem Benutzer.",
    "editToken": "Token bearbeiten"
  },
  "developerApi": {
    "description": "API-Token sind sichere, eindeutige Schlüssel, die authentifizierten Zugriff auf die Qualio-API ermöglichen. Sie ermöglichen eine nahtlose Integration mit externen Systemen zur Automatisierung von Workflows, Synchronisierung von Daten und Verbesserung der Regelkonformität-Überwachung.",
    "manageDescription": "Hier können Sie Ihre API-Token verwalten. Sie können sie erstellen, löschen und rotieren. Das Rotieren eines Token generiert einen neuen Token-Schlüssel und invalidiert den alten. Der Name und die Berechtigungen werden nicht geändert.",
    "expirationNote": "Jedes Token verfällt nach einem Jahr, wenn es nicht rotiert wird. Alle Aktionen, die mit dem Schlüssel ausgeführt werden, werden im Audit-Protokoll mit dem Namen protokolliert, den Sie für das Token wählen.",
    "docsAlert": "Sie möchten eine Integration mit der Qualio API erstellen? Leitfäden und die vollständige API-Referenz finden Sie in unserem Entwicklerportal.",
    "viewApiDocs": "API-Dokumentation ansehen",
    "createToken": "Token erstellen",
    "backToTokens": "Zurück zu API-Token",
    "createTokenHeader": "Token erstellen",
    "tokenName": "Name",
    "tokenRole": "Rolle",
    "tokenRoleHelper": "Welche Rolle sollte dieser Token haben?",
    "tokenGroups": "Gruppen",
    "tokenGroupsHelper": "Fügen Sie dieses Token optional zu Gruppen hinzu, um ihm Zugriff auf private Dokumente, Ereignisse usw. zu ermöglichen, genau wie einem Benutzer.",
    "adminAccessHelper": "Gewähren Sie diesem Token die Möglichkeit, Benutzer hinzuzufügen/zu entfernen, Gruppen hinzuzufügen/zu entfernen und Berechtigungen für Ereignisse und Lieferanten zu verwalten.",
    "tokenCreatedTitle": "Neuer Token erstellt",
    "storeSecurelyTitle": "Speichern Sie diesen Token sicher",
    "storeSecurelyMessage": "Dies ist das einzige Mal, wenn Sie das vollständige Token anzeigen können.",
    "apiTokenLabel": "API-Token",
    "copyToken": "Token kopieren",
    "tokenLostWarning": "Wenn das Token verloren geht, müssen Sie ein neues generieren. Das Generieren eines neuen Token invalidiert das alte Token, hat aber die gleichen Berechtigungen und denselben Namen.",
    "deleteToken": "Entwickler-API-Token löschen",
    "confirmDeleteTitle": "Löschen des Tokens bestätigen",
    "confirmDeleteMessage": "Sind Sie sicher, dass Sie das Token „{{tokenName}}“ löschen möchten? Jede Integration, die dieses Token verwendet, verliert sofort den Zugriff auf die Qualio-API.",
    "confirmRotateTitle": "Rotation des Tokens bestätigen",
    "confirmRotateMessage": "Sind Sie sicher, dass Sie das Token „{{tokenName}}“ rotieren möchten? Dadurch wird ein neuer Token-Schlüssel generiert und der aktuelle sofort invalidiert. Jede Integration, die ihn verwendet, verliert den Zugriff, bis sie aktualisiert wird.",
    "table": {
      "name": "Name",
      "created": "Erstellt",
      "expires": "Verfällt",
      "type": "Typ",
      "personal": "Persönlich",
      "system": "System",
      "personalTooltip": "Dieses Token ist mit einem echten Benutzer verknüpft und übernimmt dessen Zugriffsrechte. Es funktioniert nicht mehr, wenn dieser Benutzer deaktiviert wird.",
      "systemTooltip": "Dieses Token ist nicht mit einem echten Benutzer verknüpft und verfügt über eigene Berechtigungen.",
      "rotate": "Rotieren",
      "delete": "Löschen"
    }
  },
  "reassign": {
    "removeUserTitle": "Benutzer entfernen: {{name}}",
    "removeUserTitleGeneric": "Benutzer entfernen",
    "description": "Vor dem Entfernen eines Benutzers müssen Sie die Eigentümerschaft von Dokumenten und ausstehenden Problemen, Aufgaben und Maßnahmen auf andere Benutzer übertragen.",
    "descriptionEvents": "Vor dem Entfernen eines Benutzers müssen Sie die Eigentümerschaft von Dokumenten und ausstehenden Ereignissen, Aufgaben und Maßnahmen auf andere Benutzer übertragen.",
    "descriptionExtended": "Vor dem Entfernen eines Benutzers müssen Sie die Eigentümerschaft von Dokumenten, Vorlagen, ausstehenden Problemen, Aufgaben und Maßnahmen auf andere Benutzer übertragen.",
    "descriptionExtendedEvents": "Vor dem Entfernen eines Benutzers müssen Sie die Eigentümerschaft von Dokumenten, Vorlagen, ausstehenden Ereignissen, Aufgaben und Maßnahmen auf andere Benutzer übertragen.",
    "steps": {
      "documents": "Dokumente",
      "changeRequests": "Änderungsanfragen",
      "approvalActions": "Genehmigungsmaßnahmen",
      "reviewActions": "Überprüfungsmaßnahmen",
      "issues": "Probleme",
      "tasks": "Aufgaben",
      "confirmChanges": "Änderungen bestätigen und Benutzer entfernen",
      "defaultEventAssignee": "Standardzugewiesener Ereignis",
      "eventTemplates": "Ereignisvorlagen",
      "controls": "Kontrollen",
      "documentTemplates": "Dokumentvorlagen"
    },
    "bulkSelect": {
      "allSelected": "Alle {{size}} ausgewählt:",
      "save": "Speichern"
    },
    "table": {
      "id": "ID",
      "title": "Titel",
      "newOwner": "Neuer Besitzer",
      "status": "Status",
      "tags": "Tags",
      "name": "Name",
      "prefix": "Präfix"
    },
    "summary": {
      "reviewInfo": "Überprüfen Sie die folgenden Informationen",
      "addUserToGroupTitle": "Benutzer zur Gruppe hinzufügen",
      "addUserToGroupMessage": "Wenn Sie mit dem Entfernen fortfahren, werden die folgenden Benutzer den folgenden Gruppen hinzugefügt, die erforderlich sind, um auf Dokumente mit privaten Tags zuzugreifen:",
      "userAddedToGroups": "{{userName}} wird zu den Gruppen hinzugefügt: {{groupNames}}"
    }
  },
  "aria": {
    "userlistCheckbox": "userlist_checkbox",
    "addToGroup": "Zur Gruppe hinzufügen",
    "removeFromGroup": "Aus Gruppe entfernen",
    "manageGroups": "Manage groups",
    "adminAccess": "Admin-Zugriff",
    "billingAccess": "Abrechnungszugriff",
    "email": "E-Mail",
    "fullName": "Vollständiger Name",
    "role": "Rolle",
    "group": "Gruppe",
    "groupName": "Gruppenname",
    "includeInReports": "In Berichte einbeziehen",
    "inviteUserForm": "Benutzereinladungsformular",
    "groupForm": "Gruppenformular",
    "nextButton": "Schaltfläche Weiter",
    "canViewQualityEvents": "Kann Qualitätsereignisse anzeigen",
    "canCreateQualityEvents": "Kann Qualitätsereignisse erstellen",
    "canEditQualityEvents": "Kann Qualitätsereignisse bearbeiten",
    "canManageQualityEvents": "Kann Qualitätsereignisse verwalten"
  }
}
